import { NgModule } from "@angular/core";
import { Ng2StateDeclaration, UIRouterModule } from "@uirouter/angular";
import { default as dataStoryStates } from "./data-story/data-story.states";
import { ExamplesModule } from "./examples/examples.module";

const coreState = {
  name: "gh",
  abstract: true,
};

const examplesState = {
  name: "gh.examples",
  url: "/examples",
  loadChildren: (): Promise<typeof ExamplesModule> => import(/* webpackChunkName: "examples" */ "./examples/examples.module").then((m) => m.ExamplesModule),
};

const states: Ng2StateDeclaration[] = [coreState, examplesState, ...dataStoryStates];

@NgModule({
  imports: [UIRouterModule.forChild({ states })],
  exports: [UIRouterModule],
})
export class AppRoutingModule {}
